import "./SearchInput.scss";
import { MotifErrorMessage, MotifSearch } from "@ey-xd/motif-react";

export function SearchInput({
  label,
  onChange,
  onClear,
  value,
  id = crypto.randomUUID(),
  className,
  disabled = false,
  maxLength = 100,
  isError,
  errorMessage,
  disableErrorPlaceholder = true,
  hideClearButton = false,
  placeholder,
  onEnter,
  onSearchButtonClick,
  ...other
}) {
  return (
    <>
      <MotifSearch
        {...other}
        aria-label="Search"
        id={id}
        label={label}
        onChange={onChange}
        onClear={onClear}
        value={value}
        className={`app-search-input  ${className}`}
        disabled={disabled}
        maxLength={maxLength}
        hideClearButton={hideClearButton || disabled}
        placeholder={placeholder}
        onEnter={onEnter}
        onSearchButtonClick={onSearchButtonClick}
      />
      {isError ? (
        <MotifErrorMessage className="app-input-error-message">
          {errorMessage}
        </MotifErrorMessage>
      ) : !disableErrorPlaceholder ? (
        <div className="app-input-hide-error">No Error</div>
      ) : (
        <></>
      )}
    </>
  );
}
